<mat-dialog-content class="login">
    <div classs="container">
        <div class="closeHeader">
            <div class="row">
                <div class="col-5 logo">
                                    </div>
                <div class="col-7 closeIcon">
                    <span class="" (click)="closeDialog()">X</span>
                </div>
            </div>
        </div>
    </div>
    <div class="" [ngClass]="{ar: translate.currentLang =='ar'}">

        <div class="row m-0">
            <div class="col-12 col-md-4 p-0 img-section d-none d-md-flex">
                <p class="img-text">{{translate.currentLang=='en'?
                    'Explore the world deeper with us':
                    'اكتشف العالم أعمق معنا'}}
                </p>

            </div>

            <div class="col-12 col-md-8 p-0">
                <div class="closeIconWeb">
                    <span class="" (click)="closeDialog()">X</span>
                </div>
                <form [formGroup]="authService.loginForm"class="form-container">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h1 class="header-text">{{translate.currentLang=='en'?'Sign in':'تسجيل دخول'}}</h1>
                        </div>

                        <div class="col-12">
                            <mat-form-field color="accent" appearance="fill" class="authForm">
                                <input matInput formControlName="email" [placeholder]="lang == 'en' ? 'Email' : 'البريد الالكتروني'">
                                <mat-error *ngIf="getLoginFormControl('email').touched && getLoginFormControl('email').invalid">
                                    {{getEmailErrorMessage(getLoginFormControl('email'), lang)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field color="accent" appearance="fill" class="authForm">
                                <input
                                    matInput
                                    [type]="hidePassword ? 'password' : 'text'"
                                    formControlName="password"
                                    [placeholder]="lang == 'en' ? 'Password' : 'كلمة المرور'"
                                />
                                <button
                                    mat-icon-button
                                    matSuffix
                                    (click)="hidePassword = !hidePassword"
                                    [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hidePassword"
                                >
                                    <!-- <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon> -->
                                </button>
                                <mat-error *ngIf="getLoginFormControl('password').touched && getLoginFormControl('password').invalid">
                                    {{ getPasswordErrorMessage(getLoginFormControl('password'), lang) }}
                                </mat-error>

                            </mat-form-field>
                        </div>

                        <div class="col-12 mt-2" (click)="toForgetPassword()" style="text-align:start ;">
                            <span class="forgetPass">{{translate.currentLang=='en'?'Forget Password?':'نسيت كلمة السر؟'}}</span>
                        </div>

                        <div class="col-12 mt-5" (click)="onSubmit()">
                            <button *ngIf="!isLoading" class="submitBtn" mat-button color="primary" [disabled]="isLoading || !authService.loginForm.valid">
                                {{translate.currentLang=='en'?'Sign in':'تسجيل دخول'}}</button>
                            <mat-spinner *ngIf="isLoading"></mat-spinner>
                        </div>

                        <div class="col-12 mt-3" style="text-align:start ;">
                            <span class="noAccount">{{translate.currentLang=='en'?'Don’t have an account?':'ليس لديك حساب؟'}}</span>
                            <span class="crateAccount" (click)="toSignUp()">
                                {{translate.currentLang=='en'?'Sign up':'انشاء حساب جديد'}}
                            </span>
                            <!-- <span *ngIf="getScreenWidth<=500" class="crateAccount" (click)="toSignUpMob()">
                                {{translate.currentLang=='en'?'Sign up':'انشاء حساب جديد'}}
                            </span> -->
                        </div>


                        <!-- <div class="col-12 breakLine">
                            <div class="d-flex">
                                <div class="line"></div>
                                <span class="or-text">{{translate.currentLang=='en'?'OR':'أو'}}</span>
                                <div class="line"></div>
                            </div>
                        </div> -->

                        <!-- <div (click)="submitFbLogin()" class="col-12 col-xl-6 mb-3">
                            <button class="social-login" mat-button>
                                <img class="social-login-icon" src="assets/img/albaraq/icons/facebook.svg" alt="">
                                <span class="social-login-text">{{translate.currentLang=='en'?'Sign in with
                                    Facebook':'تسجيل بواسطة فيسبوك'}}</span>
                            </button>
                        </div> -->

                        <!-- <div (click)="submitGoogleLogin()" class="col-12 col-xl-6">
                            <button class="social-login" mat-button>
                                <img class="social-login-icon" src="assets/img/albaraq/icons/google.svg" alt="">
                                <span class="social-login-text">{{translate.currentLang=='en'?'Sign in with
                                    Google':'تسجيل بواسطة جوجل'}}</span>
                            </button>
                        </div> -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</mat-dialog-content>
<app-forget-password *ngIf="trigger" (clickCancel)="trigger = false"></app-forget-password>